import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { OperationTransferenceComponent } from './operation-transference.component';
import { TransferenceResultModalModule } from './modals/modal-success-transference/transference-result-modal.module';

@NgModule({
  declarations: [OperationTransferenceComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
    TransferenceResultModalModule,
  ],
  exports: [OperationTransferenceComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OperationTransferenceModule {}
